<template>
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="40" height="40" rx="20" fill="#485054" />
    <path
      d="M20.0877 12.4381C20.8951 12.4402 26.9937 12.468 28.5952 12.8898C29.5419 13.1373 30.2864 13.8694 30.5401 14.7986C31 16.4846 31 20 31 20V20.0103C31 20.2259 30.9845 23.5701 30.5401 25.2015C30.2864 26.1306 29.5419 26.8618 28.5952 27.1103C27.0319 27.5228 21.1828 27.5589 20.1547 27.5619H19.8453C18.8182 27.5589 12.9692 27.5217 11.4058 27.1103C10.4592 26.8628 9.7136 26.1306 9.45992 25.2015C9.04537 23.6784 9.00619 20.6641 9 20.0939V19.9062C9.00516 19.337 9.04537 16.3217 9.45992 14.7986C9.7136 13.8694 10.4592 13.1383 11.4048 12.8898C13.0073 12.468 19.1059 12.4402 19.9123 12.4381H20.0877ZM17.8014 16.7589V23.2422L23.5165 20L17.8014 16.7589Z"
      fill="white"
    />
  </svg>
</template>
